__turbopack_context__.v({
  "shimmer": "Skeleton-module__hVSmsq__shimmer",
  "skeleton": "Skeleton-module__hVSmsq__skeleton",
});
